import React from 'react';

// TierBadge — renders the strategy-tier field on dashboard rows that
// have one (currently GBEMI: TIER 1/2/3 and STRATA: TIER 2/4/5/6).
// Distinct from GradeBadge so the dashboard can show grade + tier
// side by side (e.g. STRATA: grade=PRIME, tier=TIER 2).
//
// Colors mirror the STRATA Monitor page so the same tier value looks
// the same wherever it appears on the app.
const TIER_COLORS = {
  'TIER 1': { color: '#84cc16', bg: 'rgba(132,204,22,0.10)', border: 'rgba(132,204,22,0.4)' },
  'TIER 2': { color: '#10b981', bg: 'rgba(16,185,129,0.10)', border: 'rgba(16,185,129,0.4)' },
  'TIER 3': { color: '#f59e0b', bg: 'rgba(245,158,11,0.10)', border: 'rgba(245,158,11,0.4)' },
  'TIER 4': { color: '#3b82f6', bg: 'rgba(59,130,246,0.10)', border: 'rgba(59,130,246,0.4)' },
  'TIER 5': { color: '#f59e0b', bg: 'rgba(245,158,11,0.10)', border: 'rgba(245,158,11,0.4)' },
  'TIER 6': { color: '#a855f7', bg: 'rgba(168,85,247,0.10)', border: 'rgba(168,85,247,0.4)' },
};

const DEFAULT = {
  color: 'var(--tv-text-muted)',
  bg: 'rgba(120,123,134,0.06)',
  border: 'rgba(120,123,134,0.18)',
};

export default function TierBadge({ tier }) {
  if (!tier) return <span style={{ color: 'var(--tv-text-muted)' }}>—</span>;
  const c = TIER_COLORS[tier] || DEFAULT;
  return (
    <span className="badge" style={{
      background: c.bg, border: `1px solid ${c.border}`, color: c.color,
      whiteSpace: 'nowrap',
    }}>
      {tier}
    </span>
  );
}
